// Copyright (c) 2026 SoundDrift. All rights reserved.

import ioSocketIO from 'socket.io-client';
import { CloudflareSocket } from './cloudflareSocket.js';

export default function io(url, options) {
  let useCloudflare = import.meta.env.VITE_USE_CLOUDFLARE === 'true' || true;
  let finalUrl = url;

  if (import.meta.env.DEV) {
    const urlParams = new URLSearchParams(window.location.search);
    finalUrl = urlParams.get('backend_url') || url;
  }

  if (useCloudflare) {
    return new CloudflareSocket(finalUrl, options);
  }
  return ioSocketIO(finalUrl, options);
}
